/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Container } from 'reactstrap';

class Video extends React.Component {
  constructor() {
    super();
    this.state = {
      display: false,
    };
  }
  openModal = () => {
    this.setState({
      display: true,
    });
  }
  closeModal = () => {
    this.setState({
      display: false,
    });
  }

  handleContextMenu = (e) => {
    e.preventDefault();
  }
  render() {
    const {
      styles: s,
    } = this.props;
    return (
      <div id="video">
        <section className={s.fizVideoArea}>
          <Container>
            <div className={s.videoContent}>
              <h3>The only AI-driven learning and organization development platform. <span>Spotmentor</span> is a platform which combines skill management, learning and development planning and business impact. We use 3 patent-pending <span>AI algorithms</span> to ensure that you are able to derive real time ROI from your learning efforts.</h3>
              <a
                onClick={this.openModal}
                className={cx(s.videoBtn, s.videoBtnTwo)}
              >
                <span className={s.btnPlay}><i className={s.arrowTriangleRight} /></span>
                  Watch Video
              </a>
            </div>
          </Container>
          {
            this.state.display &&
            <div className={s.videoModal}>
              <div
                className={cx(s.modalOverlay, { [s.showModal]: this.state.display, [s.fadeIn]: this.state.display })}
                onClick={this.closeModal}
              />
              <div
                className={cx(s.modalBody, { [s.slideDown]: this.state.display })}
              >

                <iframe className={s.video} src="https://www.youtube.com/embed/iDd0L7zGoYA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
              </div>
            </div>
          }
        </section>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/routes/home/Video.js